 const convertNumberToCurrency = (value) => {

return '$' + Number(value)
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}


export default convertNumberToCurrency